// extracted by mini-css-extract-plugin
export default {"container":"smallCard_container__pTWiw"};